import { Component, OnInit, ViewChild } from '@angular/core';

import { Utils } from '../../../../services/utils';
import { FormControl, Validators } from '@angular/forms';
import { GoogleServices } from 'src/app/services/google-service';
import { UserServices } from 'src/app/services/user.service';
import { Router } from '@angular/router';
import { CustomTranslator } from 'src/app/services/i18n';
import { link } from 'fs';
import { MatDialog } from '@angular/material/dialog';
import { ContactComponent } from '../../../../components/ui/contact/contact.component';

@Component({
    selector: 'new-profile',
    templateUrl: 'new-profile.component.html',
    styleUrls: ['./new-profile.component.scss'],
})

export class NewProfileComponent implements OnInit {
    // Patrones que indican que es una cuenta personal de Google en lugar de un perfil de empresa
    private readonly PERSONAL_INDICATORS = {
        // URLs que indican perfil personal en lugar de GMB
        personalUrls: [
            'plus.google.com/u/',
            'google.com/profile',
            'accounts.google.com',
            'gmail.com',
            'profiles.google.com'
        ],
        // Dominios de email personal 
        personalDomains: [
            '@gmail.com',
            '@hotmail.com',
            '@yahoo.com',
            '@outlook.com',
            '@live.com'
        ]
    };

    nameControl: FormControl;
    manualControl: FormControl;
    manualLinkControl: FormControl;
    countryControl: FormControl;
    cityControl: FormControl;
    countryControlM: FormControl;
    cityControlM: FormControl;
    addressControl: FormControl;
    linkControl: FormControl;

    public countrySelected;
    public countries;

    public citySelected;
    public cities;

    public address: string;
    public link: string;

    callingAPI: boolean;
    profile: any;

    public formPhase: number = 0;

    public formReady = {
        name: false,
        country: false,
        city: false,
        address: false,
        link: false
    }

    public loadingCities: boolean = false;

    constructor(
        public _i18n: CustomTranslator,
        private _utils: Utils,
        private google: GoogleServices,
        private _user: UserServices,
        private _router: Router,
        private dialog: MatDialog
    ) {}

    ngOnInit() {
        this.nameControl = new FormControl('', [Validators.required]);
        this.manualControl = new FormControl('', [Validators.required]);
        this.manualLinkControl = new FormControl('', [Validators.required]);
        this.countryControl = new FormControl('', [Validators.required]);
        this.cityControl = new FormControl('', [Validators.required]);
        this.countryControlM = new FormControl('', [Validators.required]);
        this.cityControlM = new FormControl('', [Validators.required]);
        this.addressControl = new FormControl('', [Validators.required]);
        this.linkControl = new FormControl('', [Validators.required]);
        this._loadCountries();
    }

    _loadCountries() {
        this._utils.getCountries().toPromise()
            .then((countries: Array<any>) => {
                countries.sort((a, b) => {
                    var a_value: String = a.translations.es ? a.translations.es : a.name;
                    var b_value = b.translations.es ? b.translations.es : b.name;
                    return a_value.localeCompare(b_value);
                })
                this.countries = countries;
            })
            .catch(error => {
                console.log(error);
                this._utils.showError("Error al cargar la lista de paises", 5000);
            })
    }

    nameChanged() {
        const name = this.nameControl.value;

        setTimeout(() => {
            if (name === this.nameControl.value) {
                this.formReady.name = true;
                this.checkForPersonalAccount(name, 'name');
            }
        }, 777);

        // if (this.nameControl.value == "" || this.callingAPI) return;
        // this.callingAPI = true;
        // var oldValue = this.nameControl.value
        // setTimeout(() => { this.checkInput(oldValue) }, 2500);
    }

    countryChange() {

        this.formReady.country = false;
        this.loadingCities = true;

        const alpha = this.countrySelected.alpha2Code;

        this._utils.getCities(alpha)
            .then(cities => {
                if(alpha !== this.countrySelected.alpha2Code) return;
                this.cities = cities;
                this.formReady.country = true;
                this.loadingCities = false;
            })
            .catch(error => {
                console.log(error);
                this._utils.showError("Error al cargar la lista de ciudades", 5000);
            })
    }

    cityChange() {
        this.formReady.city = true;
        this.search();
    }

    addressChange() {
        const typed = this.addressControl.value;

        setTimeout(() => {
            if (typed === this.addressControl.value){
                this.search();
                this.formReady.address = true;
            } 
        }, 777);
    }

    linkChanged() {
        const typed = this.linkControl.value;

        setTimeout(() => {
            if (typed === this.linkControl.value){
                // this.search();
                this.formReady.link = true;
                this.checkForPersonalAccount(typed, 'link');
            }
        }, 777);
    }

    private checkForPersonalAccount(text: string, type: 'name' | 'link') {
        // Si es un link, verificamos si contiene URLs de perfil personal
        if (type === 'link') {
            const isPersonalUrl = this.PERSONAL_INDICATORS.personalUrls.some(url => 
                text.toLowerCase().includes(url.toLowerCase())
            );
            if (isPersonalUrl) {
                this.showPersonalAccountWarning();
                return;
            }
        }

        // Verificamos si contiene un email personal
        const hasPersonalEmail = this.PERSONAL_INDICATORS.personalDomains.some(domain => 
            text.toLowerCase().includes(domain.toLowerCase())
        );
        
        if (hasPersonalEmail) {
            this.showPersonalAccountWarning();
        }
    }

    private showPersonalAccountWarning() {
        this._utils.openConfirmation(
            `Parece que estás intentando añadir una cuenta personal de Google. 
            Este formulario es solo para añadir perfiles de empresa. 
            Si quieres publicar reseñas y ganar dinero necesitas cambiar tu cuenta a tipo publicador. 
            ¿Deseas solicitar el cambio?`,
            'Sí, quiero ser publicador',
            'No, tengo un perfil de empresa',
            () => {
                // Obtenemos datos del usuario actual
                const user = this._user.getLocalUser();
                
                // Abrimos el diálogo de contacto con los datos pre-rellenados
                this.dialog.open(ContactComponent, {
                    width: '600px',
                    data: {
                        formData: {
                            name: user.name || '',
                            email: user.email || '',
                            message: `Hola, actualmente tengo una cuenta de empresa pero necesito cambiarla a publicador para poder realizar reseñas. Por favor, ¿podrían ayudarme a realizar este cambio? Gracias.`
                        }
                    }
                });
            }
        );
    }

    search() {

        this.callingAPI = true;

        if (!this.countrySelected || !this.citySelected) {
            this.countryControl.markAsTouched();
            this.cityControl.markAsTouched();
            this.callingAPI = false;
            return;
        }

        var name = this._removeAccent(this.nameControl.value + ' ' + this.citySelected.name);
        name = name.split(" ").join("+");

        if(this.addressControl.value) name += '+' + this._removeAccent(this.addressControl.value).split(" ").join("+");

        this.google.searchGoogle(name).subscribe(
            result => {
                this.profile = result;
                this.callingAPI = false;
            },
            error => {
                this.profile = null;
                this.callingAPI = false;
                // this.nameControl.setErrors({ NotFound: true });
                if(this.formPhase < 2){
                    this._utils.showError("No se ha encontrado ningún perfil. Danos más información por favor.", 5000);
                    this.formPhase++;
                }
            }
        );

    }

    save() {
        this.profile['keywords'] = this.nameControl.value;
        this.profile['country'] = this.countrySelected.name;
        this.profile['city'] = this.citySelected.name;

        this._user.createProfile(this.profile).toPromise()
            .then(result => {
                //update cache
                var user = this._user.getLocalUser();
                if (user.profiles) user.profiles = user.profiles.concat([result['profile']]);
                else user.profiles = [result['profile']];
                this._user.setLocalUser(user);

                this._router.navigate(["/es/dashboard/profiles"]);
            })
            .catch(error => {
                console.log(error);
                this._utils.showError("Error al guardar perfil.", 5000);
            });
    }

    public rejectProfile() {
        this.profile = null;
        this.formPhase++;
    }

    checkInput(oldValue) {
        //INPUT DID NOT CHANGE IN 3000ms
        if (this.nameControl.value === oldValue) {
            this.callingAPI = true;
            this.search();
        }
        //INPUT CHANGED
        else {
            setTimeout(() => { this.checkInput(this.nameControl.value) }, 2500);
        }
    }





    saveManual() {

        const data = {
            name: this.nameControl.value,
            country: this.countrySelected.name,
            city: this.citySelected.name,
            address: this.addressControl.value,
            link: this.linkControl.value
        }

        this._user.createProfileManual(data).toPromise()
        .then(result => {
            //update cache
            var user = this._user.getLocalUser();
            if (user.profiles) user.profiles = user.profiles.concat([result['profile']]);
            else user.profiles = [result['profile']];
            this._user.setLocalUser(user);

            this._router.navigate(["/es/dashboard/profiles"]);
        })
        .catch(error => {
            console.log(error);
            this._utils.showError("Error al guardar perfil.", 5000);
        });
        
    }

    private _removeAccent(text: string) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, "");
    }



}
